var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 850,
    height: 388,
    viewBox: "0 0 850 388",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M850 375.5C850 382.404 659.721 388 425 388C190.279 388 0 382.404 0 375.5C0 368.596 190.279 363 425 363C659.721 363 850 368.596 850 375.5Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M521.455 224.181C521.455 218.658 525.932 214.181 531.455 214.181H787.794C793.317 214.181 797.794 218.658 797.794 224.181V352.979C797.794 358.502 793.317 362.979 787.794 362.979H531.455C525.932 362.979 521.455 358.502 521.455 352.979V224.181Z",
    fill: "#0006FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M516.141 224.182C516.141 218.659 520.618 214.182 526.141 214.182H782.48C788.003 214.182 792.48 218.659 792.48 224.182V352.98C792.48 358.503 788.003 362.98 782.48 362.98H526.141C520.618 362.98 516.141 358.503 516.141 352.98V224.182Z",
    fill: "#4044FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M524.644 335.345H662.813V356.602H524.644V335.345Z",
    fill: "#D5D6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M524.644 224.811H563.969V246.067H524.644V224.811Z",
    fill: "#D5D6FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M574.597 224.81H646.871V246.066H574.597V224.81Z",
    fill: "#D5D6FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M567.157 224.811H571.409V246.067H567.157V224.811Z",
    fill: "#D5D6FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M677.157 320.463C677.157 318.906 677.469 317.702 678.102 316.851C678.735 316 679.482 315.575 680.354 315.575C681.216 315.575 681.963 316 682.596 316.851C683.219 317.702 683.541 318.906 683.541 320.463C683.541 322.02 683.219 323.224 682.596 324.075C681.963 324.926 681.216 325.352 680.354 325.352C679.482 325.352 678.735 324.926 678.102 324.075C677.469 323.224 677.157 322.02 677.157 320.463ZM686.727 320.463C686.727 318.138 686.104 316.27 684.869 314.848C683.624 313.426 682.119 312.71 680.354 312.71C678.579 312.71 677.074 313.426 675.829 314.848C674.583 316.27 673.96 318.138 673.96 320.463C673.96 322.788 674.583 324.667 675.829 326.089C677.074 327.521 678.579 328.227 680.354 328.227C682.119 328.227 683.624 327.521 684.869 326.089C686.104 324.667 686.727 322.788 686.727 320.463Z",
    fill: "#D5D6FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M690.983 320.463C690.983 318.906 691.294 317.702 691.927 316.851C692.56 316 693.308 315.575 694.179 315.575C695.041 315.575 695.788 316 696.421 316.851C697.044 317.702 697.366 318.906 697.366 320.463C697.366 322.02 697.044 323.224 696.421 324.075C695.788 324.926 695.041 325.352 694.179 325.352C693.308 325.352 692.56 324.926 691.927 324.075C691.294 323.224 690.983 322.02 690.983 320.463ZM700.552 320.463C700.552 318.138 699.93 316.27 698.694 314.848C697.449 313.426 695.944 312.71 694.179 312.71C692.405 312.71 690.9 313.426 689.654 314.848C688.408 316.27 687.786 318.138 687.786 320.463C687.786 322.788 688.408 324.667 689.654 326.089C690.9 327.521 692.405 328.227 694.179 328.227C695.944 328.227 697.449 327.521 698.694 326.089C699.93 324.667 700.552 322.788 700.552 320.463Z",
    fill: "#D5D6FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M710.766 312.814H708.108L701.725 332.368H704.382L710.766 312.814Z",
    fill: "#D5D6FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M715.125 320.463C715.125 318.906 715.436 317.702 716.069 316.851C716.703 316 717.45 315.575 718.322 315.575C719.183 315.575 719.93 316 720.564 316.851C721.186 317.702 721.508 318.906 721.508 320.463C721.508 322.02 721.186 323.224 720.564 324.075C719.93 324.926 719.183 325.352 718.322 325.352C717.45 325.352 716.703 324.926 716.069 324.075C715.436 323.224 715.125 322.02 715.125 320.463ZM724.695 320.463C724.695 318.138 724.072 316.27 722.837 314.848C721.591 313.426 720.086 312.71 718.322 312.71C716.547 312.71 715.042 313.426 713.796 314.848C712.551 316.27 711.928 318.138 711.928 320.463C711.928 322.788 712.551 324.667 713.796 326.089C715.042 327.521 716.547 328.227 718.322 328.227C720.086 328.227 721.591 327.521 722.837 326.089C724.072 324.667 724.695 322.788 724.695 320.463Z",
    fill: "#D5D6FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M728.95 320.463C728.95 318.906 729.262 317.702 729.895 316.851C730.528 316 731.275 315.575 732.147 315.575C733.008 315.575 733.756 316 734.389 316.851C735.012 317.702 735.333 318.906 735.333 320.463C735.333 322.02 735.012 323.224 734.389 324.075C733.756 324.926 733.008 325.352 732.147 325.352C731.275 325.352 730.528 324.926 729.895 324.075C729.262 323.224 728.95 322.02 728.95 320.463ZM738.52 320.463C738.52 318.138 737.897 316.27 736.662 314.848C735.416 313.426 733.911 312.71 732.147 312.71C730.372 312.71 728.867 313.426 727.622 314.848C726.376 316.27 725.753 318.138 725.753 320.463C725.753 322.788 726.376 324.667 727.622 326.089C728.867 327.521 730.372 328.227 732.147 328.227C733.911 328.227 735.416 327.521 736.662 326.089C737.897 324.667 738.52 322.788 738.52 320.463Z",
    fill: "#D5D6FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M531.028 293.446L533.443 296.988L536.223 294.754L533.625 291.594L537.53 290.467L536.422 287.125L532.517 288.615L532.88 284.328H529.157L529.538 288.615L525.633 287.125L524.507 290.467L528.412 291.594L525.815 294.754L528.594 296.988L531.028 293.446Z",
    fill: "#D5D6FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M545.922 293.446L548.338 296.988L551.117 294.754L548.519 291.594L552.425 290.467L551.317 287.125L547.411 288.615L547.775 284.328H544.051L544.433 288.615L540.527 287.125L539.401 290.467L543.306 291.594L540.709 294.754L543.488 296.988L545.922 293.446Z",
    fill: "#D5D6FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M560.816 293.446L563.232 296.988L566.011 294.754L563.414 291.594L567.319 290.467L566.211 287.125L562.306 288.615L562.669 284.328H558.945L559.327 288.615L555.422 287.125L554.296 290.467L558.201 291.594L555.603 294.754L558.382 296.988L560.816 293.446Z",
    fill: "#D5D6FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M575.711 293.446L578.126 296.988L580.906 294.754L578.308 291.594L582.213 290.467L581.105 287.125L577.2 288.615L577.563 284.328H573.84L574.221 288.615L570.316 287.125L569.19 290.467L573.095 291.594L570.498 294.754L573.277 296.988L575.711 293.446Z",
    fill: "#D5D6FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M598.234 293.446L600.65 296.988L603.429 294.754L600.831 291.594L604.736 290.467L603.628 287.125L599.723 288.615L600.087 284.328H596.363L596.744 288.615L592.839 287.125L591.713 290.467L595.618 291.594L593.021 294.754L595.8 296.988L598.234 293.446Z",
    fill: "#D5D6FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M613.128 293.446L615.544 296.988L618.323 294.754L615.726 291.594L619.631 290.467L618.523 287.125L614.618 288.615L614.981 284.328H611.257L611.639 288.615L607.733 287.125L606.607 290.467L610.513 291.594L607.915 294.754L610.694 296.988L613.128 293.446Z",
    fill: "#D5D6FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M628.022 293.446L630.438 296.988L633.217 294.754L630.62 291.594L634.525 290.467L633.417 287.125L629.512 288.615L629.875 284.328H626.152L626.533 288.615L622.628 287.125L621.502 290.467L625.407 291.594L622.809 294.754L625.589 296.988L628.022 293.446Z",
    fill: "#D5D6FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M642.917 293.446L645.333 296.988L648.112 294.754L645.514 291.594L649.419 290.467L648.311 287.125L644.406 288.615L644.77 284.328H641.046L641.427 288.615L637.522 287.125L636.396 290.467L640.301 291.594L637.704 294.754L640.483 296.988L642.917 293.446Z",
    fill: "#D5D6FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M665.44 293.446L667.856 296.988L670.635 294.754L668.037 291.594L671.943 290.467L670.835 287.125L666.929 288.615L667.293 284.328H663.569L663.951 288.615L660.045 287.125L658.919 290.467L662.824 291.594L660.227 294.754L663.006 296.988L665.44 293.446Z",
    fill: "#D5D6FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M680.334 293.446L682.75 296.988L685.529 294.754L682.932 291.594L686.837 290.467L685.729 287.125L681.824 288.615L682.187 284.328H678.463L678.845 288.615L674.94 287.125L673.813 290.467L677.719 291.594L675.121 294.754L677.9 296.988L680.334 293.446Z",
    fill: "#D5D6FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M695.229 293.446L697.644 296.988L700.423 294.754L697.826 291.594L701.731 290.467L700.623 287.125L696.718 288.615L697.081 284.328H693.358L693.739 288.615L689.834 287.125L688.708 290.467L692.613 291.594L690.016 294.754L692.795 296.988L695.229 293.446Z",
    fill: "#D5D6FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M710.123 293.446L712.539 296.988L715.318 294.754L712.72 291.594L716.626 290.467L715.518 287.125L711.612 288.615L711.976 284.328H708.252L708.634 288.615L704.728 287.125L703.602 290.467L707.507 291.594L704.91 294.754L707.689 296.988L710.123 293.446Z",
    fill: "#D5D6FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M732.646 293.446L735.062 296.988L737.841 294.754L735.244 291.594L739.149 290.467L738.041 287.125L734.136 288.615L734.499 284.328H730.775L731.157 288.615L727.251 287.125L726.125 290.467L730.03 291.594L727.433 294.754L730.212 296.988L732.646 293.446Z",
    fill: "#D5D6FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M747.54 293.446L749.956 296.988L752.735 294.754L750.138 291.594L754.043 290.467L752.935 287.125L749.03 288.615L749.393 284.328H745.67L746.051 288.615L742.146 287.125L741.02 290.467L744.925 291.594L742.327 294.754L745.106 296.988L747.54 293.446Z",
    fill: "#D5D6FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M762.435 293.446L764.851 296.988L767.63 294.754L765.032 291.594L768.937 290.467L767.829 287.125L763.924 288.615L764.287 284.328H760.564L760.945 288.615L757.04 287.125L755.914 290.467L759.819 291.594L757.222 294.754L760.001 296.988L762.435 293.446Z",
    fill: "#D5D6FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M777.329 293.446L779.745 296.988L782.524 294.754L779.927 291.594L783.832 290.467L782.724 287.125L778.819 288.615L779.182 284.328H775.458L775.84 288.615L771.934 287.125L770.808 290.467L774.714 291.594L772.116 294.754L774.895 296.988L777.329 293.446Z",
    fill: "#D5D6FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M119.446 339.656C119.446 338.552 120.342 337.656 121.446 337.656H252.611C253.715 337.656 254.611 338.552 254.611 339.656V365.498C254.611 366.602 253.715 367.498 252.611 367.498H121.446C120.342 367.498 119.446 366.602 119.446 365.498V339.656Z",
    fill: "#E8974D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M121.202 339.406C122.171 339.406 122.957 340.192 122.957 341.162V363.982C122.957 364.951 122.171 365.737 121.202 365.737C120.232 365.737 119.446 364.951 119.446 363.982V341.162C119.446 340.192 120.232 339.406 121.202 339.406Z",
    fill: "url(#paint0_linear_1584_1545)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M129.979 339.406C130.948 339.406 131.734 340.192 131.734 341.162V363.982C131.734 364.951 130.948 365.737 129.979 365.737H128.223C127.254 365.737 126.468 364.951 126.468 363.982V341.162C126.468 340.192 127.254 339.406 128.223 339.406H129.979Z",
    fill: "url(#paint1_linear_1584_1545)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M135.245 341.162C135.245 340.192 136.031 339.406 137 339.406H138.755C139.725 339.406 140.511 340.192 140.511 341.162V363.982C140.511 364.951 139.725 365.737 138.755 365.737H137C136.031 365.737 135.245 364.951 135.245 363.982V341.162Z",
    fill: "url(#paint2_linear_1584_1545)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M147.532 339.406C148.502 339.406 149.288 340.192 149.288 341.162V363.982C149.288 364.951 148.502 365.737 147.532 365.737H145.777C144.808 365.737 144.022 364.951 144.022 363.982V341.162C144.022 340.192 144.808 339.406 145.777 339.406H147.532Z",
    fill: "url(#paint3_linear_1584_1545)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M152.799 341.162C152.799 340.192 153.584 339.406 154.554 339.406H156.309C157.279 339.406 158.065 340.192 158.065 341.162V363.982C158.065 364.951 157.279 365.737 156.309 365.737H154.554C153.584 365.737 152.799 364.951 152.799 363.982V341.162Z",
    fill: "url(#paint4_linear_1584_1545)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M165.086 339.406C166.056 339.406 166.842 340.192 166.842 341.162V363.982C166.842 364.951 166.056 365.737 165.086 365.737H163.331C162.361 365.737 161.575 364.951 161.575 363.982V341.162C161.575 340.192 162.361 339.406 163.331 339.406H165.086Z",
    fill: "url(#paint5_linear_1584_1545)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M170.352 341.162C170.352 340.192 171.138 339.406 172.108 339.406H173.863C174.833 339.406 175.618 340.192 175.618 341.162V363.982C175.618 364.951 174.833 365.737 173.863 365.737H172.108C171.138 365.737 170.352 364.951 170.352 363.982V341.162Z",
    fill: "url(#paint6_linear_1584_1545)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M182.64 339.406C183.609 339.406 184.395 340.192 184.395 341.162V363.982C184.395 364.951 183.609 365.737 182.64 365.737H180.885C179.915 365.737 179.129 364.951 179.129 363.982V341.162C179.129 340.192 179.915 339.406 180.885 339.406H182.64Z",
    fill: "url(#paint7_linear_1584_1545)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M187.906 341.162C187.906 340.192 188.692 339.406 189.661 339.406H191.417C192.386 339.406 193.172 340.192 193.172 341.162V363.982C193.172 364.951 192.386 365.737 191.417 365.737H189.661C188.692 365.737 187.906 364.951 187.906 363.982V341.162Z",
    fill: "url(#paint8_linear_1584_1545)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M200.194 339.406C201.163 339.406 201.949 340.192 201.949 341.162V363.982C201.949 364.951 201.163 365.737 200.194 365.737H198.438C197.469 365.737 196.683 364.951 196.683 363.982V341.162C196.683 340.192 197.469 339.406 198.438 339.406H200.194Z",
    fill: "url(#paint9_linear_1584_1545)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M205.46 341.162C205.46 340.192 206.246 339.406 207.215 339.406H208.971C209.94 339.406 210.726 340.192 210.726 341.162V363.982C210.726 364.951 209.94 365.737 208.971 365.737H207.215C206.246 365.737 205.46 364.951 205.46 363.982V341.162Z",
    fill: "url(#paint10_linear_1584_1545)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M217.748 339.406C218.717 339.406 219.503 340.192 219.503 341.162V363.982C219.503 364.951 218.717 365.737 217.748 365.737H215.992C215.023 365.737 214.237 364.951 214.237 363.982V341.162C214.237 340.192 215.023 339.406 215.992 339.406H217.748Z",
    fill: "url(#paint11_linear_1584_1545)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M223.014 341.162C223.014 340.192 223.8 339.406 224.769 339.406H226.524C227.494 339.406 228.28 340.192 228.28 341.162V363.982C228.28 364.951 227.494 365.737 226.524 365.737H224.769C223.8 365.737 223.014 364.951 223.014 363.982V341.162Z",
    fill: "url(#paint12_linear_1584_1545)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M235.301 339.406C236.271 339.406 237.057 340.192 237.057 341.162V363.982C237.057 364.951 236.271 365.737 235.301 365.737H233.546C232.577 365.737 231.791 364.951 231.791 363.982V341.162C231.791 340.192 232.577 339.406 233.546 339.406H235.301Z",
    fill: "url(#paint13_linear_1584_1545)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M240.568 341.162C240.568 340.192 241.353 339.406 242.323 339.406H244.078C245.048 339.406 245.834 340.192 245.834 341.162V363.982C245.834 364.951 245.048 365.737 244.078 365.737H242.323C241.353 365.737 240.568 364.951 240.568 363.982V341.162Z",
    fill: "url(#paint14_linear_1584_1545)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M251.1 339.406C252.069 339.406 252.855 340.192 252.855 341.162V363.982C252.855 364.951 252.069 365.737 251.1 365.737C250.13 365.737 249.344 364.951 249.344 363.982V341.162C249.344 340.192 250.13 339.406 251.1 339.406Z",
    fill: "url(#paint15_linear_1584_1545)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M119.446 307.33C119.446 306.226 120.342 305.33 121.446 305.33H252.611C253.715 305.33 254.611 306.226 254.611 307.33V333.172C254.611 334.276 253.715 335.172 252.611 335.172H121.446C120.342 335.172 119.446 334.276 119.446 333.172V307.33Z",
    fill: "#E8974D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M121.202 307.08C122.171 307.08 122.957 307.866 122.957 308.835V331.655C122.957 332.625 122.171 333.411 121.202 333.411C120.232 333.411 119.446 332.625 119.446 331.655V308.835C119.446 307.866 120.232 307.08 121.202 307.08Z",
    fill: "url(#paint16_linear_1584_1545)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M129.979 307.08C130.948 307.08 131.734 307.866 131.734 308.835V331.655C131.734 332.625 130.948 333.411 129.979 333.411H128.223C127.254 333.411 126.468 332.625 126.468 331.655V308.835C126.468 307.866 127.254 307.08 128.223 307.08H129.979Z",
    fill: "url(#paint17_linear_1584_1545)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M135.245 308.835C135.245 307.866 136.031 307.08 137 307.08H138.755C139.725 307.08 140.511 307.866 140.511 308.835V331.655C140.511 332.625 139.725 333.411 138.755 333.411H137C136.031 333.411 135.245 332.625 135.245 331.655V308.835Z",
    fill: "url(#paint18_linear_1584_1545)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M147.532 307.08C148.502 307.08 149.288 307.866 149.288 308.835V331.655C149.288 332.625 148.502 333.411 147.532 333.411H145.777C144.808 333.411 144.022 332.625 144.022 331.655V308.835C144.022 307.866 144.808 307.08 145.777 307.08H147.532Z",
    fill: "url(#paint19_linear_1584_1545)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M152.799 308.835C152.799 307.866 153.584 307.08 154.554 307.08H156.309C157.279 307.08 158.065 307.866 158.065 308.835V331.655C158.065 332.625 157.279 333.411 156.309 333.411H154.554C153.584 333.411 152.799 332.625 152.799 331.655V308.835Z",
    fill: "url(#paint20_linear_1584_1545)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M165.086 307.08C166.056 307.08 166.842 307.866 166.842 308.835V331.655C166.842 332.625 166.056 333.411 165.086 333.411H163.331C162.361 333.411 161.575 332.625 161.575 331.655V308.835C161.575 307.866 162.361 307.08 163.331 307.08H165.086Z",
    fill: "url(#paint21_linear_1584_1545)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M170.352 308.835C170.352 307.866 171.138 307.08 172.108 307.08H173.863C174.833 307.08 175.618 307.866 175.618 308.835V331.655C175.618 332.625 174.833 333.411 173.863 333.411H172.108C171.138 333.411 170.352 332.625 170.352 331.655V308.835Z",
    fill: "url(#paint22_linear_1584_1545)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M182.64 307.08C183.609 307.08 184.395 307.866 184.395 308.835V331.655C184.395 332.625 183.609 333.411 182.64 333.411H180.885C179.915 333.411 179.129 332.625 179.129 331.655V308.835C179.129 307.866 179.915 307.08 180.885 307.08H182.64Z",
    fill: "url(#paint23_linear_1584_1545)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M187.906 308.835C187.906 307.866 188.692 307.08 189.661 307.08H191.417C192.386 307.08 193.172 307.866 193.172 308.835V331.655C193.172 332.625 192.386 333.411 191.417 333.411H189.661C188.692 333.411 187.906 332.625 187.906 331.655V308.835Z",
    fill: "url(#paint24_linear_1584_1545)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M200.194 307.08C201.163 307.08 201.949 307.866 201.949 308.835V331.655C201.949 332.625 201.163 333.411 200.194 333.411H198.438C197.469 333.411 196.683 332.625 196.683 331.655V308.835C196.683 307.866 197.469 307.08 198.438 307.08H200.194Z",
    fill: "url(#paint25_linear_1584_1545)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M205.46 308.835C205.46 307.866 206.246 307.08 207.215 307.08H208.971C209.94 307.08 210.726 307.866 210.726 308.835V331.655C210.726 332.625 209.94 333.411 208.971 333.411H207.215C206.246 333.411 205.46 332.625 205.46 331.655V308.835Z",
    fill: "url(#paint26_linear_1584_1545)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M217.748 307.08C218.717 307.08 219.503 307.866 219.503 308.835V331.655C219.503 332.625 218.717 333.411 217.748 333.411H215.992C215.023 333.411 214.237 332.625 214.237 331.655V308.835C214.237 307.866 215.023 307.08 215.992 307.08H217.748Z",
    fill: "url(#paint27_linear_1584_1545)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M223.014 308.835C223.014 307.866 223.8 307.08 224.769 307.08H226.524C227.494 307.08 228.28 307.866 228.28 308.835V331.655C228.28 332.625 227.494 333.411 226.524 333.411H224.769C223.8 333.411 223.014 332.625 223.014 331.655V308.835Z",
    fill: "url(#paint28_linear_1584_1545)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M235.301 307.08C236.271 307.08 237.057 307.866 237.057 308.835V331.655C237.057 332.625 236.271 333.411 235.301 333.411H233.546C232.577 333.411 231.791 332.625 231.791 331.655V308.835C231.791 307.866 232.577 307.08 233.546 307.08H235.301Z",
    fill: "url(#paint29_linear_1584_1545)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M240.568 308.835C240.568 307.866 241.353 307.08 242.323 307.08H244.078C245.048 307.08 245.834 307.866 245.834 308.835V331.655C245.834 332.625 245.048 333.411 244.078 333.411H242.323C241.353 333.411 240.568 332.625 240.568 331.655V308.835Z",
    fill: "url(#paint30_linear_1584_1545)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M251.1 307.08C252.069 307.08 252.855 307.866 252.855 308.835V331.655C252.855 332.625 252.069 333.411 251.1 333.411C250.13 333.411 249.344 332.625 249.344 331.655V308.835C249.344 307.866 250.13 307.08 251.1 307.08Z",
    fill: "url(#paint31_linear_1584_1545)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M119.446 275.003C119.446 273.898 120.342 273.003 121.446 273.003H252.611C253.715 273.003 254.611 273.898 254.611 275.003V300.844C254.611 301.949 253.715 302.844 252.611 302.844H121.446C120.342 302.844 119.446 301.949 119.446 300.844V275.003Z",
    fill: "#E8974D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M121.202 274.753C122.171 274.753 122.957 275.539 122.957 276.508V299.328C122.957 300.298 122.171 301.084 121.202 301.084C120.232 301.084 119.446 300.298 119.446 299.328V276.508C119.446 275.539 120.232 274.753 121.202 274.753Z",
    fill: "url(#paint32_linear_1584_1545)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M129.979 274.753C130.948 274.753 131.734 275.539 131.734 276.508V299.328C131.734 300.298 130.948 301.084 129.979 301.084H128.223C127.254 301.084 126.468 300.298 126.468 299.328V276.508C126.468 275.539 127.254 274.753 128.223 274.753H129.979Z",
    fill: "url(#paint33_linear_1584_1545)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M135.245 276.508C135.245 275.539 136.031 274.753 137 274.753H138.755C139.725 274.753 140.511 275.539 140.511 276.508V299.328C140.511 300.298 139.725 301.084 138.755 301.084H137C136.031 301.084 135.245 300.298 135.245 299.328V276.508Z",
    fill: "url(#paint34_linear_1584_1545)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M147.532 274.753C148.502 274.753 149.288 275.539 149.288 276.508V299.328C149.288 300.298 148.502 301.084 147.532 301.084H145.777C144.808 301.084 144.022 300.298 144.022 299.328V276.508C144.022 275.539 144.808 274.753 145.777 274.753H147.532Z",
    fill: "url(#paint35_linear_1584_1545)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M152.799 276.508C152.799 275.539 153.584 274.753 154.554 274.753H156.309C157.279 274.753 158.065 275.539 158.065 276.508V299.328C158.065 300.298 157.279 301.084 156.309 301.084H154.554C153.584 301.084 152.799 300.298 152.799 299.328V276.508Z",
    fill: "url(#paint36_linear_1584_1545)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M165.086 274.753C166.056 274.753 166.842 275.539 166.842 276.508V299.328C166.842 300.298 166.056 301.084 165.086 301.084H163.331C162.361 301.084 161.575 300.298 161.575 299.328V276.508C161.575 275.539 162.361 274.753 163.331 274.753H165.086Z",
    fill: "url(#paint37_linear_1584_1545)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M170.352 276.508C170.352 275.539 171.138 274.753 172.108 274.753H173.863C174.833 274.753 175.618 275.539 175.618 276.508V299.328C175.618 300.298 174.833 301.084 173.863 301.084H172.108C171.138 301.084 170.352 300.298 170.352 299.328V276.508Z",
    fill: "url(#paint38_linear_1584_1545)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M182.64 274.753C183.609 274.753 184.395 275.539 184.395 276.508V299.328C184.395 300.298 183.609 301.084 182.64 301.084H180.885C179.915 301.084 179.129 300.298 179.129 299.328V276.508C179.129 275.539 179.915 274.753 180.885 274.753H182.64Z",
    fill: "url(#paint39_linear_1584_1545)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M187.906 276.508C187.906 275.539 188.692 274.753 189.661 274.753H191.417C192.386 274.753 193.172 275.539 193.172 276.508V299.328C193.172 300.298 192.386 301.084 191.417 301.084H189.661C188.692 301.084 187.906 300.298 187.906 299.328V276.508Z",
    fill: "url(#paint40_linear_1584_1545)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M200.194 274.753C201.163 274.753 201.949 275.539 201.949 276.508V299.328C201.949 300.298 201.163 301.084 200.194 301.084H198.438C197.469 301.084 196.683 300.298 196.683 299.328V276.508C196.683 275.539 197.469 274.753 198.438 274.753H200.194Z",
    fill: "url(#paint41_linear_1584_1545)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M205.46 276.508C205.46 275.539 206.246 274.753 207.215 274.753H208.971C209.94 274.753 210.726 275.539 210.726 276.508V299.328C210.726 300.298 209.94 301.084 208.971 301.084H207.215C206.246 301.084 205.46 300.298 205.46 299.328V276.508Z",
    fill: "url(#paint42_linear_1584_1545)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M217.748 274.753C218.717 274.753 219.503 275.539 219.503 276.508V299.328C219.503 300.298 218.717 301.084 217.748 301.084H215.992C215.023 301.084 214.237 300.298 214.237 299.328V276.508C214.237 275.539 215.023 274.753 215.992 274.753H217.748Z",
    fill: "url(#paint43_linear_1584_1545)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M223.014 276.508C223.014 275.539 223.8 274.753 224.769 274.753H226.524C227.494 274.753 228.28 275.539 228.28 276.508V299.328C228.28 300.298 227.494 301.084 226.524 301.084H224.769C223.8 301.084 223.014 300.298 223.014 299.328V276.508Z",
    fill: "url(#paint44_linear_1584_1545)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M235.301 274.753C236.271 274.753 237.057 275.539 237.057 276.508V299.328C237.057 300.298 236.271 301.084 235.301 301.084H233.546C232.577 301.084 231.791 300.298 231.791 299.328V276.508C231.791 275.539 232.577 274.753 233.546 274.753H235.301Z",
    fill: "url(#paint45_linear_1584_1545)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M240.568 276.508C240.568 275.539 241.353 274.753 242.323 274.753H244.078C245.048 274.753 245.834 275.539 245.834 276.508V299.328C245.834 300.298 245.048 301.084 244.078 301.084H242.323C241.353 301.084 240.568 300.298 240.568 299.328V276.508Z",
    fill: "url(#paint46_linear_1584_1545)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M251.1 274.753C252.069 274.753 252.855 275.539 252.855 276.508V299.328C252.855 300.298 252.069 301.084 251.1 301.084C250.13 301.084 249.344 300.298 249.344 299.328V276.508C249.344 275.539 250.13 274.753 251.1 274.753Z",
    fill: "url(#paint47_linear_1584_1545)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M119.446 242.665C119.446 241.56 120.342 240.665 121.446 240.665H252.611C253.715 240.665 254.611 241.56 254.611 242.665V268.506C254.611 269.611 253.715 270.507 252.611 270.507H121.446C120.342 270.507 119.446 269.611 119.446 268.507V242.665Z",
    fill: "#E8974D"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M121.202 242.415C122.171 242.415 122.957 243.201 122.957 244.17V266.99C122.957 267.96 122.171 268.746 121.202 268.746C120.232 268.746 119.446 267.96 119.446 266.99V244.17C119.446 243.201 120.232 242.415 121.202 242.415Z",
    fill: "url(#paint48_linear_1584_1545)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M129.979 242.415C130.948 242.415 131.734 243.201 131.734 244.17V266.99C131.734 267.96 130.948 268.746 129.979 268.746H128.223C127.254 268.746 126.468 267.96 126.468 266.99V244.17C126.468 243.201 127.254 242.415 128.223 242.415H129.979Z",
    fill: "url(#paint49_linear_1584_1545)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M135.245 244.17C135.245 243.201 136.031 242.415 137 242.415H138.755C139.725 242.415 140.511 243.201 140.511 244.17V266.99C140.511 267.96 139.725 268.746 138.755 268.746H137C136.031 268.746 135.245 267.96 135.245 266.99V244.17Z",
    fill: "url(#paint50_linear_1584_1545)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M147.532 242.415C148.502 242.415 149.288 243.201 149.288 244.17V266.99C149.288 267.96 148.502 268.746 147.532 268.746H145.777C144.808 268.746 144.022 267.96 144.022 266.99V244.17C144.022 243.201 144.808 242.415 145.777 242.415H147.532Z",
    fill: "url(#paint51_linear_1584_1545)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M152.799 244.17C152.799 243.201 153.584 242.415 154.554 242.415H156.309C157.279 242.415 158.065 243.201 158.065 244.17V266.99C158.065 267.96 157.279 268.746 156.309 268.746H154.554C153.584 268.746 152.799 267.96 152.799 266.99V244.17Z",
    fill: "url(#paint52_linear_1584_1545)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M165.086 242.415C166.056 242.415 166.842 243.201 166.842 244.17V266.99C166.842 267.96 166.056 268.746 165.086 268.746H163.331C162.361 268.746 161.575 267.96 161.575 266.99V244.17C161.575 243.201 162.361 242.415 163.331 242.415H165.086Z",
    fill: "url(#paint53_linear_1584_1545)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M170.352 244.17C170.352 243.201 171.138 242.415 172.108 242.415H173.863C174.833 242.415 175.618 243.201 175.618 244.17V266.99C175.618 267.96 174.833 268.746 173.863 268.746H172.108C171.138 268.746 170.352 267.96 170.352 266.99V244.17Z",
    fill: "url(#paint54_linear_1584_1545)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M182.64 242.415C183.609 242.415 184.395 243.201 184.395 244.17V266.99C184.395 267.96 183.609 268.746 182.64 268.746H180.885C179.915 268.746 179.129 267.96 179.129 266.99V244.17C179.129 243.201 179.915 242.415 180.885 242.415H182.64Z",
    fill: "url(#paint55_linear_1584_1545)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M187.906 244.17C187.906 243.201 188.692 242.415 189.661 242.415H191.417C192.386 242.415 193.172 243.201 193.172 244.17V266.99C193.172 267.96 192.386 268.746 191.417 268.746H189.661C188.692 268.746 187.906 267.96 187.906 266.99V244.17Z",
    fill: "url(#paint56_linear_1584_1545)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M200.194 242.415C201.163 242.415 201.949 243.201 201.949 244.17V266.99C201.949 267.96 201.163 268.746 200.194 268.746H198.438C197.469 268.746 196.683 267.96 196.683 266.99V244.17C196.683 243.201 197.469 242.415 198.438 242.415H200.194Z",
    fill: "url(#paint57_linear_1584_1545)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M205.46 244.17C205.46 243.201 206.246 242.415 207.215 242.415H208.971C209.94 242.415 210.726 243.201 210.726 244.17V266.99C210.726 267.96 209.94 268.746 208.971 268.746H207.215C206.246 268.746 205.46 267.96 205.46 266.99V244.17Z",
    fill: "url(#paint58_linear_1584_1545)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M217.748 242.415C218.717 242.415 219.503 243.201 219.503 244.17V266.99C219.503 267.96 218.717 268.746 217.748 268.746H215.992C215.023 268.746 214.237 267.96 214.237 266.99V244.17C214.237 243.201 215.023 242.415 215.992 242.415H217.748Z",
    fill: "url(#paint59_linear_1584_1545)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M223.014 244.17C223.014 243.201 223.8 242.415 224.769 242.415H226.524C227.494 242.415 228.28 243.201 228.28 244.17V266.99C228.28 267.96 227.494 268.746 226.524 268.746H224.769C223.8 268.746 223.014 267.96 223.014 266.99V244.17Z",
    fill: "url(#paint60_linear_1584_1545)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M235.301 242.415C236.271 242.415 237.057 243.201 237.057 244.17V266.99C237.057 267.96 236.271 268.746 235.301 268.746H233.546C232.577 268.746 231.791 267.96 231.791 266.99V244.17C231.791 243.201 232.577 242.415 233.546 242.415H235.301Z",
    fill: "url(#paint61_linear_1584_1545)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M240.568 244.17C240.568 243.201 241.353 242.415 242.323 242.415H244.078C245.048 242.415 245.834 243.201 245.834 244.17V266.99C245.834 267.96 245.048 268.746 244.078 268.746H242.323C241.353 268.746 240.568 267.96 240.568 266.99V244.17Z",
    fill: "url(#paint62_linear_1584_1545)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M251.1 242.415C252.069 242.415 252.855 243.201 252.855 244.17V266.99C252.855 267.96 252.069 268.746 251.1 268.746C250.13 268.746 249.344 267.96 249.344 266.99V244.17C249.344 243.201 250.13 242.415 251.1 242.415Z",
    fill: "url(#paint63_linear_1584_1545)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M119.446 210.326C119.446 209.222 120.342 208.326 121.446 208.326H252.611C253.715 208.326 254.611 209.222 254.611 210.326V236.168C254.611 237.272 253.715 238.168 252.611 238.168H121.446C120.342 238.168 119.446 237.272 119.446 236.168V210.326Z",
    fill: "#E8974D"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M121.202 210.076C122.171 210.076 122.957 210.862 122.957 211.832V234.651C122.957 235.621 122.171 236.407 121.202 236.407C120.232 236.407 119.446 235.621 119.446 234.651V211.832C119.446 210.862 120.232 210.076 121.202 210.076Z",
    fill: "url(#paint64_linear_1584_1545)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M129.979 210.076C130.948 210.076 131.734 210.862 131.734 211.832V234.651C131.734 235.621 130.948 236.407 129.979 236.407H128.223C127.254 236.407 126.468 235.621 126.468 234.651V211.832C126.468 210.862 127.254 210.076 128.223 210.076H129.979Z",
    fill: "url(#paint65_linear_1584_1545)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M135.245 211.832C135.245 210.862 136.031 210.076 137 210.076H138.755C139.725 210.076 140.511 210.862 140.511 211.832V234.651C140.511 235.621 139.725 236.407 138.755 236.407H137C136.031 236.407 135.245 235.621 135.245 234.651V211.832Z",
    fill: "url(#paint66_linear_1584_1545)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M147.532 210.076C148.502 210.076 149.288 210.862 149.288 211.832V234.651C149.288 235.621 148.502 236.407 147.532 236.407H145.777C144.808 236.407 144.022 235.621 144.022 234.651V211.832C144.022 210.862 144.808 210.076 145.777 210.076H147.532Z",
    fill: "url(#paint67_linear_1584_1545)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M152.799 211.832C152.799 210.862 153.584 210.076 154.554 210.076H156.309C157.279 210.076 158.065 210.862 158.065 211.832V234.651C158.065 235.621 157.279 236.407 156.309 236.407H154.554C153.584 236.407 152.799 235.621 152.799 234.651V211.832Z",
    fill: "url(#paint68_linear_1584_1545)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M165.086 210.076C166.056 210.076 166.842 210.862 166.842 211.832V234.651C166.842 235.621 166.056 236.407 165.086 236.407H163.331C162.361 236.407 161.575 235.621 161.575 234.651V211.832C161.575 210.862 162.361 210.076 163.331 210.076H165.086Z",
    fill: "url(#paint69_linear_1584_1545)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M170.352 211.832C170.352 210.862 171.138 210.076 172.108 210.076H173.863C174.833 210.076 175.618 210.862 175.618 211.832V234.651C175.618 235.621 174.833 236.407 173.863 236.407H172.108C171.138 236.407 170.352 235.621 170.352 234.651V211.832Z",
    fill: "url(#paint70_linear_1584_1545)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M182.64 210.076C183.609 210.076 184.395 210.862 184.395 211.832V234.651C184.395 235.621 183.609 236.407 182.64 236.407H180.885C179.915 236.407 179.129 235.621 179.129 234.651V211.832C179.129 210.862 179.915 210.076 180.885 210.076H182.64Z",
    fill: "url(#paint71_linear_1584_1545)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M187.906 211.832C187.906 210.862 188.692 210.076 189.661 210.076H191.417C192.386 210.076 193.172 210.862 193.172 211.832V234.651C193.172 235.621 192.386 236.407 191.417 236.407H189.661C188.692 236.407 187.906 235.621 187.906 234.651V211.832Z",
    fill: "url(#paint72_linear_1584_1545)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M200.194 210.076C201.163 210.076 201.949 210.862 201.949 211.832V234.651C201.949 235.621 201.163 236.407 200.194 236.407H198.438C197.469 236.407 196.683 235.621 196.683 234.651V211.832C196.683 210.862 197.469 210.076 198.438 210.076H200.194Z",
    fill: "url(#paint73_linear_1584_1545)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M205.46 211.832C205.46 210.862 206.246 210.076 207.215 210.076H208.971C209.94 210.076 210.726 210.862 210.726 211.832V234.651C210.726 235.621 209.94 236.407 208.971 236.407H207.215C206.246 236.407 205.46 235.621 205.46 234.651V211.832Z",
    fill: "url(#paint74_linear_1584_1545)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M217.748 210.076C218.717 210.076 219.503 210.862 219.503 211.832V234.651C219.503 235.621 218.717 236.407 217.748 236.407H215.992C215.023 236.407 214.237 235.621 214.237 234.651V211.832C214.237 210.862 215.023 210.076 215.992 210.076H217.748Z",
    fill: "url(#paint75_linear_1584_1545)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M223.014 211.832C223.014 210.862 223.8 210.076 224.769 210.076H226.524C227.494 210.076 228.28 210.862 228.28 211.832V234.651C228.28 235.621 227.494 236.407 226.524 236.407H224.769C223.8 236.407 223.014 235.621 223.014 234.651V211.832Z",
    fill: "url(#paint76_linear_1584_1545)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M235.301 210.076C236.271 210.076 237.057 210.862 237.057 211.832V234.651C237.057 235.621 236.271 236.407 235.301 236.407H233.546C232.577 236.407 231.791 235.621 231.791 234.651V211.832C231.791 210.862 232.577 210.076 233.546 210.076H235.301Z",
    fill: "url(#paint77_linear_1584_1545)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M240.568 211.832C240.568 210.862 241.353 210.076 242.323 210.076H244.078C245.048 210.076 245.834 210.862 245.834 211.832V234.651C245.834 235.621 245.048 236.407 244.078 236.407H242.323C241.353 236.407 240.568 235.621 240.568 234.651V211.832Z",
    fill: "url(#paint78_linear_1584_1545)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M251.1 210.076C252.069 210.076 252.855 210.862 252.855 211.832V234.651C252.855 235.621 252.069 236.407 251.1 236.407C250.13 236.407 249.344 235.621 249.344 234.651V211.832C249.344 210.862 250.13 210.076 251.1 210.076Z",
    fill: "url(#paint79_linear_1584_1545)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M119.446 178C119.446 176.895 120.342 176 121.446 176H252.611C253.715 176 254.611 176.895 254.611 178V203.841C254.611 204.946 253.715 205.841 252.611 205.841H121.446C120.342 205.841 119.446 204.946 119.446 203.841V178Z",
    fill: "#E8974D"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M121.202 177.75C122.171 177.75 122.957 178.536 122.957 179.505V202.325C122.957 203.295 122.171 204.081 121.202 204.081C120.232 204.081 119.446 203.295 119.446 202.325V179.505C119.446 178.536 120.232 177.75 121.202 177.75Z",
    fill: "url(#paint80_linear_1584_1545)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M129.979 177.75C130.948 177.75 131.734 178.536 131.734 179.505V202.325C131.734 203.295 130.948 204.081 129.979 204.081H128.223C127.254 204.081 126.468 203.295 126.468 202.325V179.505C126.468 178.536 127.254 177.75 128.223 177.75H129.979Z",
    fill: "url(#paint81_linear_1584_1545)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M135.245 179.505C135.245 178.536 136.031 177.75 137 177.75H138.755C139.725 177.75 140.511 178.536 140.511 179.505V202.325C140.511 203.295 139.725 204.081 138.755 204.081H137C136.031 204.081 135.245 203.295 135.245 202.325V179.505Z",
    fill: "url(#paint82_linear_1584_1545)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M147.532 177.75C148.502 177.75 149.288 178.536 149.288 179.505V202.325C149.288 203.295 148.502 204.081 147.532 204.081H145.777C144.808 204.081 144.022 203.295 144.022 202.325V179.505C144.022 178.536 144.808 177.75 145.777 177.75H147.532Z",
    fill: "url(#paint83_linear_1584_1545)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M152.799 179.505C152.799 178.536 153.584 177.75 154.554 177.75H156.309C157.279 177.75 158.065 178.536 158.065 179.505V202.325C158.065 203.295 157.279 204.081 156.309 204.081H154.554C153.584 204.081 152.799 203.295 152.799 202.325V179.505Z",
    fill: "url(#paint84_linear_1584_1545)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M165.086 177.75C166.056 177.75 166.842 178.536 166.842 179.505V202.325C166.842 203.295 166.056 204.081 165.086 204.081H163.331C162.361 204.081 161.575 203.295 161.575 202.325V179.505C161.575 178.536 162.361 177.75 163.331 177.75H165.086Z",
    fill: "url(#paint85_linear_1584_1545)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M170.352 179.505C170.352 178.536 171.138 177.75 172.108 177.75H173.863C174.833 177.75 175.618 178.536 175.618 179.505V202.325C175.618 203.295 174.833 204.081 173.863 204.081H172.108C171.138 204.081 170.352 203.295 170.352 202.325V179.505Z",
    fill: "url(#paint86_linear_1584_1545)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M182.64 177.75C183.609 177.75 184.395 178.536 184.395 179.505V202.325C184.395 203.295 183.609 204.081 182.64 204.081H180.885C179.915 204.081 179.129 203.295 179.129 202.325V179.505C179.129 178.536 179.915 177.75 180.885 177.75H182.64Z",
    fill: "url(#paint87_linear_1584_1545)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M187.906 179.505C187.906 178.536 188.692 177.75 189.661 177.75H191.417C192.386 177.75 193.172 178.536 193.172 179.505V202.325C193.172 203.295 192.386 204.081 191.417 204.081H189.661C188.692 204.081 187.906 203.295 187.906 202.325V179.505Z",
    fill: "url(#paint88_linear_1584_1545)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M200.194 177.75C201.163 177.75 201.949 178.536 201.949 179.505V202.325C201.949 203.295 201.163 204.081 200.194 204.081H198.438C197.469 204.081 196.683 203.295 196.683 202.325V179.505C196.683 178.536 197.469 177.75 198.438 177.75H200.194Z",
    fill: "url(#paint89_linear_1584_1545)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M205.46 179.505C205.46 178.536 206.246 177.75 207.215 177.75H208.971C209.94 177.75 210.726 178.536 210.726 179.505V202.325C210.726 203.295 209.94 204.081 208.971 204.081H207.215C206.246 204.081 205.46 203.295 205.46 202.325V179.505Z",
    fill: "url(#paint90_linear_1584_1545)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M217.748 177.75C218.717 177.75 219.503 178.536 219.503 179.505V202.325C219.503 203.295 218.717 204.081 217.748 204.081H215.992C215.023 204.081 214.237 203.295 214.237 202.325V179.505C214.237 178.536 215.023 177.75 215.992 177.75H217.748Z",
    fill: "url(#paint91_linear_1584_1545)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M223.014 179.505C223.014 178.536 223.8 177.75 224.769 177.75H226.524C227.494 177.75 228.28 178.536 228.28 179.505V202.325C228.28 203.295 227.494 204.081 226.524 204.081H224.769C223.8 204.081 223.014 203.295 223.014 202.325V179.505Z",
    fill: "url(#paint92_linear_1584_1545)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M235.301 177.75C236.271 177.75 237.057 178.536 237.057 179.505V202.325C237.057 203.295 236.271 204.081 235.301 204.081H233.546C232.577 204.081 231.791 203.295 231.791 202.325V179.505C231.791 178.536 232.577 177.75 233.546 177.75H235.301Z",
    fill: "url(#paint93_linear_1584_1545)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M240.568 179.505C240.568 178.536 241.353 177.75 242.323 177.75H244.078C245.048 177.75 245.834 178.536 245.834 179.505V202.325C245.834 203.295 245.048 204.081 244.078 204.081H242.323C241.353 204.081 240.568 203.295 240.568 202.325V179.505Z",
    fill: "url(#paint94_linear_1584_1545)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M251.1 177.75C252.069 177.75 252.855 178.536 252.855 179.505V202.325C252.855 203.295 252.069 204.081 251.1 204.081C250.13 204.081 249.344 203.295 249.344 202.325V179.505C249.344 178.536 250.13 177.75 251.1 177.75Z",
    fill: "url(#paint95_linear_1584_1545)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M180.924 301.733C180.924 333.625 155.071 359.477 123.18 359.477C91.2888 359.477 65.436 333.625 65.436 301.733C65.436 269.842 91.2888 243.989 123.18 243.989C155.071 243.989 180.924 269.842 180.924 301.733Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.36 301.742C195.36 341.606 163.044 373.922 123.18 373.922C83.316 373.922 51 341.606 51 301.742C51 261.878 83.316 229.562 123.18 229.562C163.044 229.562 195.36 261.878 195.36 301.742ZM123.18 359.486C155.071 359.486 180.924 333.633 180.924 301.742C180.924 269.85 155.071 243.998 123.18 243.998C91.2888 243.998 65.436 269.85 65.436 301.742C65.436 333.633 91.2888 359.486 123.18 359.486Z",
    fill: "#E8974D"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.36 301.742C196.36 342.158 163.596 374.922 123.18 374.922C82.7637 374.922 50 342.158 50 301.742C50 261.325 82.7637 228.562 123.18 228.562C163.596 228.562 196.36 261.325 196.36 301.742ZM123.18 358.486C154.519 358.486 179.924 333.08 179.924 301.742C179.924 270.403 154.519 244.998 123.18 244.998C91.8411 244.998 66.436 270.403 66.436 301.742C66.436 333.08 91.8411 358.486 123.18 358.486ZM123.18 373.922C163.044 373.922 195.36 341.606 195.36 301.742C195.36 261.878 163.044 229.562 123.18 229.562C83.316 229.562 51 261.878 51 301.742C51 341.606 83.316 373.922 123.18 373.922ZM180.924 301.742C180.924 333.633 155.071 359.486 123.18 359.486C91.2888 359.486 65.436 333.633 65.436 301.742C65.436 269.85 91.2888 243.998 123.18 243.998C155.071 243.998 180.924 269.85 180.924 301.742Z",
    fill: "#FAB400"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.36 301.742C195.36 341.606 163.044 373.922 123.18 373.922C83.316 373.922 51 341.606 51 301.742C51 261.878 83.316 229.562 123.18 229.562C163.044 229.562 195.36 261.878 195.36 301.742ZM123.18 359.486C155.071 359.486 180.924 333.633 180.924 301.742C180.924 269.85 155.071 243.998 123.18 243.998C91.2888 243.998 65.436 269.85 65.436 301.742C65.436 333.633 91.2888 359.486 123.18 359.486Z",
    fill: "url(#paint96_linear_1584_1545)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M180.924 301.733C180.924 333.625 155.071 359.477 123.18 359.477C91.2888 359.477 65.436 333.625 65.436 301.733C65.436 269.842 91.2888 243.989 123.18 243.989C155.071 243.989 180.924 269.842 180.924 301.733Z",
    fill: "#E8974D"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M129.307 265.542C132.588 266.212 135.601 267.317 138.346 268.856C141.091 270.363 142.999 271.685 144.07 272.823L145.727 274.581L136.488 284.373C136.086 283.904 135.517 283.335 134.78 282.665C134.077 281.962 132.571 281.042 130.261 279.903C127.951 278.765 125.575 278.196 123.131 278.196C120.185 278.196 117.808 278.949 116 280.456C114.226 281.962 113.339 283.787 113.339 285.929C113.339 288.339 114.544 290.281 116.955 291.754C119.398 293.193 122.344 294.415 125.792 295.42C129.274 296.424 132.755 297.595 136.237 298.935C139.752 300.274 142.731 302.483 145.175 305.563C147.618 308.642 148.84 312.542 148.84 317.263C148.84 322.753 147.116 327.473 143.668 331.423C140.254 335.373 135.467 337.951 129.307 339.156V349.148H115.9V339.507C113.222 339.106 110.644 338.436 108.167 337.499C105.723 336.561 103.698 335.591 102.091 334.586C100.484 333.549 99.0617 332.528 97.8231 331.523C96.5845 330.519 95.6974 329.716 95.1617 329.113L94.3081 328.058L103.598 318.819C104.066 319.355 104.719 320.058 105.556 320.928C106.426 321.765 108.334 322.903 111.28 324.343C114.226 325.782 117.306 326.502 120.52 326.502C124.236 326.502 127.131 325.631 129.207 323.891C131.316 322.15 132.37 319.941 132.37 317.263C132.37 314.852 131.148 312.911 128.705 311.438C126.294 309.965 123.332 308.743 119.817 307.772C116.335 306.768 112.854 305.596 109.372 304.257C105.924 302.918 102.978 300.709 100.535 297.629C98.0909 294.549 96.869 290.649 96.869 285.929C96.869 281.008 98.5763 276.623 101.991 272.773C105.439 268.923 110.075 266.48 115.9 265.442V255.55H129.307V265.542Z",
    fill: "#FFEF9E"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M344.171 148.591V300.494H394.805V148.591H445.439V300.494H496.073V148.591H546.707V300.494H575.189C577.707 300.494 580.122 301.494 581.902 303.274C583.683 305.055 584.683 307.47 584.683 309.988V325.811H255.561V309.988C255.561 307.47 256.561 305.055 258.342 303.274C260.122 301.494 262.537 300.494 265.055 300.494H293.537V148.591H344.171Z",
    fill: "#B8BAFF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M606.092 92.1032L422.543 22.4813C420.993 21.8396 394.233 21.8396 392.683 22.4813L234.152 92.1032C232.996 92.5821 232.007 93.3931 231.312 94.4338C230.616 95.4745 230.244 96.6981 230.244 97.9499V110.608C230.244 112.287 230.911 113.897 232.098 115.084C233.285 116.271 234.895 116.938 236.573 116.938H255.561V126.432C255.561 128.95 256.561 131.364 258.342 133.145C260.122 134.925 262.537 135.926 265.055 135.926H575.189C577.707 135.926 580.122 134.925 581.902 133.145C583.683 131.364 584.683 128.95 584.683 126.432V116.938H603.671C605.35 116.938 606.96 116.271 608.146 115.084C609.333 113.897 610 112.287 610 110.608V97.9499C610 96.6981 609.629 95.4745 608.933 94.4338C608.237 93.3931 607.249 92.5821 606.092 92.1032ZM591.012 338.462H249.232C244.196 338.462 239.366 340.463 235.806 344.023C232.245 347.584 230.244 352.414 230.244 357.45V370.108C230.244 371.787 230.911 373.397 232.098 374.584C233.285 375.771 234.895 376.438 236.573 376.438H603.671C605.35 376.438 606.96 375.771 608.146 374.584C609.333 373.397 610 371.787 610 370.108V357.45C610 352.414 608 347.584 604.439 344.023C600.878 340.463 596.048 338.462 591.012 338.462Z",
    fill: "#B8BAFF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M230.561 325.811H584.683C584.797 330.028 586.222 338.462 591.012 338.462H224.232C229.217 338.462 230.529 330.028 230.561 325.811Z",
    fill: "#B8BAFF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M318.927 148.591V300.493H369.561V148.591H420.195V300.493H470.829V148.591H521.463V300.493H549.945C552.463 300.493 554.878 301.493 556.658 303.274C558.439 305.054 559.439 307.469 559.439 309.987V325.81H230.317V309.987C230.317 307.469 231.317 305.054 233.098 303.274C234.878 301.493 237.293 300.493 239.811 300.493H268.293V148.591H318.927Z",
    fill: "#F0F0F0"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.293 300.493H239.811C237.293 300.493 234.878 301.493 233.098 303.274C231.317 305.054 230.317 307.469 230.317 309.987V325.81H559.439V309.987C559.439 307.469 558.439 305.054 556.658 303.274C554.878 301.493 552.463 300.493 549.945 300.493H521.463V148.591H470.829V300.493H420.195V148.591H369.561V300.493H318.927V148.591H268.293V300.493ZM269.293 149.591V301.493H239.811C237.558 301.493 235.398 302.388 233.805 303.981C232.212 305.574 231.317 307.734 231.317 309.987V324.81H558.439V309.987C558.439 307.734 557.544 305.574 555.951 303.981C554.358 302.388 552.198 301.493 549.945 301.493H520.463V149.591H471.829V301.493H419.195V149.591H370.561V301.493H317.927V149.591H269.293Z",
    fill: "#C4C4C4"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M230.561 325.811H559.17C559.284 330.028 560.71 338.462 565.5 338.462H224.231C229.217 338.462 230.528 330.028 230.561 325.811Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M580.848 92.1032L397.299 22.4813C395.749 21.8396 394.007 21.8396 392.457 22.4813L208.908 92.1032C207.752 92.5821 206.763 93.3931 206.067 94.4338C205.372 95.4745 205 96.6981 205 97.9499V110.608C205 112.287 205.667 113.897 206.854 115.084C208.041 116.271 209.651 116.938 211.329 116.938H230.317V126.432C230.317 128.95 231.317 131.364 233.098 133.145C234.878 134.925 237.293 135.926 239.811 135.926H549.945C552.463 135.926 554.878 134.925 556.658 133.145C558.439 131.364 559.439 128.95 559.439 126.432V116.938H578.427C580.105 116.938 581.715 116.271 582.902 115.084C584.089 113.897 584.756 112.287 584.756 110.608V97.9499C584.756 96.6981 584.384 95.4745 583.689 94.4338C582.993 93.3931 582.004 92.5821 580.848 92.1032ZM565.768 338.462H223.988C218.952 338.462 214.122 340.463 210.561 344.023C207 347.584 205 352.414 205 357.45V370.108C205 371.787 205.667 373.397 206.854 374.584C208.041 375.771 209.651 376.438 211.329 376.438H578.427C580.105 376.438 581.715 375.771 582.902 374.584C584.089 373.397 584.756 371.787 584.756 370.108V357.45C584.756 352.414 582.756 347.584 579.195 344.023C575.634 340.463 570.804 338.462 565.768 338.462Z",
    fill: "#F0F0F0"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.93 23.411L396.917 23.4053C395.611 22.8649 394.145 22.8649 392.84 23.4053L392.826 23.411L209.278 93.0327C208.309 93.4365 207.482 94.1172 206.899 94.9895C206.313 95.8657 206 96.896 206 97.9499C206 97.95 206 97.9498 206 97.9499V110.608C206 112.022 206.561 113.377 207.561 114.377C208.56 115.376 209.916 115.938 211.329 115.938H231.317V126.432C231.317 128.684 232.212 130.845 233.805 132.438C235.398 134.031 237.558 134.926 239.811 134.926H549.945C552.198 134.926 554.358 134.031 555.951 132.438C557.544 130.845 558.439 128.684 558.439 126.432V115.938H578.427C579.84 115.938 581.196 115.376 582.195 114.377C583.195 113.377 583.756 112.022 583.756 110.608V97.9499C583.756 96.8961 583.443 95.8658 582.857 94.9895C582.274 94.1173 581.447 93.4366 580.479 93.0327C580.474 93.0309 580.47 93.029 580.465 93.0272L396.93 23.411ZM580.848 92.1032C582.004 92.5821 582.993 93.3931 583.689 94.4338C584.384 95.4745 584.756 96.6981 584.756 97.9499V110.608C584.756 112.287 584.089 113.897 582.902 115.084C581.715 116.271 580.105 116.938 578.427 116.938H559.439V126.432C559.439 128.95 558.439 131.364 556.658 133.145C554.878 134.925 552.463 135.926 549.945 135.926H239.811C237.293 135.926 234.878 134.925 233.098 133.145C231.317 131.364 230.317 128.95 230.317 126.432V116.938H211.329C209.651 116.938 208.041 116.271 206.854 115.084C205.667 113.897 205 112.287 205 110.608V97.9499C205 96.6981 205.372 95.4745 206.067 94.4338C206.763 93.3931 207.752 92.5821 208.908 92.1032L392.457 22.4813C394.007 21.8396 395.749 21.8396 397.299 22.4813L580.848 92.1032ZM565.768 339.462H223.988C219.217 339.462 214.642 341.357 211.269 344.731C207.895 348.104 206 352.679 206 357.45V370.108C206 371.522 206.561 372.877 207.561 373.877C208.56 374.876 209.916 375.438 211.329 375.438H578.427C579.84 375.438 581.196 374.876 582.195 373.877C583.195 372.877 583.756 371.522 583.756 370.108V357.45C583.756 352.679 581.861 348.104 578.488 344.731C575.114 341.357 570.539 339.462 565.768 339.462ZM223.988 338.462H565.768C570.804 338.462 575.634 340.463 579.195 344.023C582.756 347.584 584.756 352.414 584.756 357.45V370.108C584.756 371.787 584.089 373.397 582.902 374.584C581.715 375.771 580.105 376.438 578.427 376.438H211.329C209.651 376.438 208.041 375.771 206.854 374.584C205.667 373.397 205 371.787 205 370.108V357.45C205 352.414 207 347.584 210.561 344.023C214.122 340.463 218.952 338.462 223.988 338.462Z",
    fill: "#C4C4C4"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M434 96C434 116.435 417.435 133 397 133C376.565 133 360 116.435 360 96C360 75.5655 376.565 59 397 59C417.435 59 434 75.5655 434 96Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397 132C416.882 132 433 115.882 433 96C433 76.1177 416.882 60 397 60C377.118 60 361 76.1177 361 96C361 115.882 377.118 132 397 132ZM397 133C417.435 133 434 116.435 434 96C434 75.5655 417.435 59 397 59C376.565 59 360 75.5655 360 96C360 116.435 376.565 133 397 133Z",
    fill: "#C4C4C4"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M400.612 74.5515C402.357 74.9235 403.959 75.5372 405.419 76.3927C406.879 77.2296 407.893 77.9642 408.463 78.5966L409.344 79.573L404.431 85.0129L401.5 85C401.5 85 402.348 83.1624 401.12 82.53C399.891 81.8977 398.627 81.5815 397.328 81.5815C395.761 81.5815 394.497 82 393.536 82.8369C392.592 83.6738 392.121 84.6874 392.121 85.8777C392.121 87.2167 392.762 88.2954 394.043 89.1137C395.343 89.9134 396.909 90.5923 398.743 91.1502C400.595 91.7082 402.446 92.3591 404.297 93.103C406.167 93.8469 407.751 95.0744 409.051 96.7854C410.35 98.4964 411 100.663 411 103.285C411 106.335 410.083 108.958 408.25 111.152C406.434 113.347 403.888 114.779 400.612 115.448V121H393.483V115.644C392.058 115.421 390.688 115.049 389.37 114.528C388.071 114.007 386.994 113.468 386.139 112.91C385.285 112.333 384.528 111.766 383.869 111.208C383.211 110.65 382.739 110.204 382.454 109.869L382 109.283L383.869 104.15H386.94C387.189 104.448 387.537 104.838 387.982 105.322C388.444 105.787 389.459 106.419 391.026 107.219C392.592 108.019 394.23 108.418 395.939 108.418C397.915 108.418 399.455 107.935 400.559 106.968C401.68 106.001 402.241 104.773 402.241 103.285C402.241 101.946 401.591 100.868 400.292 100.049C399.01 99.231 397.435 98.5522 395.565 98.0129C393.714 97.4549 391.862 96.804 390.011 96.0601C388.177 95.3162 386.611 94.0887 385.311 92.3777C384.012 90.6667 383.362 88.5 383.362 85.8777C383.362 83.1438 384.27 80.7074 386.086 78.5687C387.919 76.4299 390.385 75.0722 393.483 74.4957V69H400.612V74.5515Z",
    fill: "#5358FF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M397.612 74.5515C399.357 74.9235 400.959 75.5372 402.419 76.3927C403.879 77.2296 404.893 77.9642 405.463 78.5966L406.344 79.573L401.431 85.0129C401.217 84.7525 400.915 84.4363 400.523 84.0644C400.149 83.6738 399.348 83.1624 398.12 82.53C396.891 81.8977 395.627 81.5815 394.328 81.5815C392.761 81.5815 391.497 82 390.536 82.8369C389.592 83.6738 389.121 84.6874 389.121 85.8777C389.121 87.2167 389.762 88.2954 391.043 89.1137C392.343 89.9134 393.909 90.5923 395.743 91.1502C397.595 91.7082 399.446 92.3591 401.297 93.103C403.167 93.8469 404.751 95.0744 406.051 96.7854C407.35 98.4964 408 100.663 408 103.285C408 106.335 407.083 108.958 405.25 111.152C403.434 113.347 400.888 114.779 397.612 115.448V121H390.483V115.644C389.058 115.421 387.688 115.049 386.37 114.528C385.071 114.007 383.994 113.468 383.139 112.91C382.285 112.333 381.528 111.766 380.869 111.208C380.211 110.65 379.739 110.204 379.454 109.869L379 109.283L383.94 104.15C384.189 104.448 384.537 104.838 384.982 105.322C385.444 105.787 386.459 106.419 388.026 107.219C389.592 108.019 391.23 108.418 392.939 108.418C394.915 108.418 396.455 107.935 397.559 106.968C398.68 106.001 399.241 104.773 399.241 103.285C399.241 101.946 398.591 100.868 397.292 100.049C396.01 99.231 394.435 98.5522 392.565 98.0129C390.714 97.4549 388.862 96.804 387.011 96.0601C385.177 95.3162 383.611 94.0887 382.311 92.3777C381.012 90.6667 380.362 88.5 380.362 85.8777C380.362 83.1438 381.27 80.7074 383.086 78.5687C384.919 76.4299 387.385 75.0722 390.483 74.4957V69H397.612V74.5515Z",
    fill: "#B8BAFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1584_1545",
    x1: 178.252,
    y1: 329.752,
    x2: 186.151,
    y2: 365.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1584_1545",
    x1: 178.252,
    y1: 329.752,
    x2: 186.151,
    y2: 365.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1584_1545",
    x1: 178.252,
    y1: 329.752,
    x2: 186.151,
    y2: 365.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1584_1545",
    x1: 178.252,
    y1: 329.752,
    x2: 186.151,
    y2: 365.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1584_1545",
    x1: 178.252,
    y1: 329.752,
    x2: 186.151,
    y2: 365.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1584_1545",
    x1: 178.252,
    y1: 329.752,
    x2: 186.151,
    y2: 365.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1584_1545",
    x1: 178.252,
    y1: 329.752,
    x2: 186.151,
    y2: 365.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1584_1545",
    x1: 178.252,
    y1: 329.752,
    x2: 186.151,
    y2: 365.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1584_1545",
    x1: 178.252,
    y1: 329.752,
    x2: 186.151,
    y2: 365.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1584_1545",
    x1: 178.252,
    y1: 329.752,
    x2: 186.151,
    y2: 365.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1584_1545",
    x1: 178.252,
    y1: 329.752,
    x2: 186.151,
    y2: 365.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1584_1545",
    x1: 178.252,
    y1: 329.752,
    x2: 186.151,
    y2: 365.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1584_1545",
    x1: 178.252,
    y1: 329.752,
    x2: 186.151,
    y2: 365.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1584_1545",
    x1: 178.252,
    y1: 329.752,
    x2: 186.151,
    y2: 365.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1584_1545",
    x1: 178.252,
    y1: 329.752,
    x2: 186.151,
    y2: 365.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1584_1545",
    x1: 178.252,
    y1: 329.752,
    x2: 186.151,
    y2: 365.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1584_1545",
    x1: 178.252,
    y1: 297.425,
    x2: 186.151,
    y2: 333.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1584_1545",
    x1: 178.252,
    y1: 297.425,
    x2: 186.151,
    y2: 333.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1584_1545",
    x1: 178.252,
    y1: 297.425,
    x2: 186.151,
    y2: 333.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1584_1545",
    x1: 178.252,
    y1: 297.425,
    x2: 186.151,
    y2: 333.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1584_1545",
    x1: 178.252,
    y1: 297.425,
    x2: 186.151,
    y2: 333.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1584_1545",
    x1: 178.252,
    y1: 297.425,
    x2: 186.151,
    y2: 333.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1584_1545",
    x1: 178.252,
    y1: 297.425,
    x2: 186.151,
    y2: 333.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1584_1545",
    x1: 178.252,
    y1: 297.425,
    x2: 186.151,
    y2: 333.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1584_1545",
    x1: 178.252,
    y1: 297.425,
    x2: 186.151,
    y2: 333.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1584_1545",
    x1: 178.252,
    y1: 297.425,
    x2: 186.151,
    y2: 333.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1584_1545",
    x1: 178.252,
    y1: 297.425,
    x2: 186.151,
    y2: 333.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1584_1545",
    x1: 178.252,
    y1: 297.425,
    x2: 186.151,
    y2: 333.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1584_1545",
    x1: 178.252,
    y1: 297.425,
    x2: 186.151,
    y2: 333.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1584_1545",
    x1: 178.252,
    y1: 297.425,
    x2: 186.151,
    y2: 333.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1584_1545",
    x1: 178.252,
    y1: 297.425,
    x2: 186.151,
    y2: 333.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1584_1545",
    x1: 178.252,
    y1: 297.425,
    x2: 186.151,
    y2: 333.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1584_1545",
    x1: 178.252,
    y1: 265.098,
    x2: 186.151,
    y2: 301.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1584_1545",
    x1: 178.252,
    y1: 265.098,
    x2: 186.151,
    y2: 301.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1584_1545",
    x1: 178.252,
    y1: 265.098,
    x2: 186.151,
    y2: 301.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1584_1545",
    x1: 178.252,
    y1: 265.098,
    x2: 186.151,
    y2: 301.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1584_1545",
    x1: 178.252,
    y1: 265.098,
    x2: 186.151,
    y2: 301.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1584_1545",
    x1: 178.252,
    y1: 265.098,
    x2: 186.151,
    y2: 301.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1584_1545",
    x1: 178.252,
    y1: 265.098,
    x2: 186.151,
    y2: 301.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1584_1545",
    x1: 178.252,
    y1: 265.098,
    x2: 186.151,
    y2: 301.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1584_1545",
    x1: 178.252,
    y1: 265.098,
    x2: 186.151,
    y2: 301.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1584_1545",
    x1: 178.252,
    y1: 265.098,
    x2: 186.151,
    y2: 301.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1584_1545",
    x1: 178.252,
    y1: 265.098,
    x2: 186.151,
    y2: 301.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1584_1545",
    x1: 178.252,
    y1: 265.098,
    x2: 186.151,
    y2: 301.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1584_1545",
    x1: 178.252,
    y1: 265.098,
    x2: 186.151,
    y2: 301.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1584_1545",
    x1: 178.252,
    y1: 265.098,
    x2: 186.151,
    y2: 301.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1584_1545",
    x1: 178.252,
    y1: 265.098,
    x2: 186.151,
    y2: 301.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1584_1545",
    x1: 178.252,
    y1: 265.098,
    x2: 186.151,
    y2: 301.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1584_1545",
    x1: 178.252,
    y1: 232.76,
    x2: 186.151,
    y2: 268.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1584_1545",
    x1: 178.252,
    y1: 232.76,
    x2: 186.151,
    y2: 268.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1584_1545",
    x1: 178.252,
    y1: 232.76,
    x2: 186.151,
    y2: 268.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1584_1545",
    x1: 178.252,
    y1: 232.76,
    x2: 186.151,
    y2: 268.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1584_1545",
    x1: 178.252,
    y1: 232.76,
    x2: 186.151,
    y2: 268.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1584_1545",
    x1: 178.252,
    y1: 232.76,
    x2: 186.151,
    y2: 268.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1584_1545",
    x1: 178.252,
    y1: 232.76,
    x2: 186.151,
    y2: 268.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1584_1545",
    x1: 178.252,
    y1: 232.76,
    x2: 186.151,
    y2: 268.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1584_1545",
    x1: 178.252,
    y1: 232.76,
    x2: 186.151,
    y2: 268.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1584_1545",
    x1: 178.252,
    y1: 232.76,
    x2: 186.151,
    y2: 268.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1584_1545",
    x1: 178.252,
    y1: 232.76,
    x2: 186.151,
    y2: 268.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1584_1545",
    x1: 178.252,
    y1: 232.76,
    x2: 186.151,
    y2: 268.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1584_1545",
    x1: 178.252,
    y1: 232.76,
    x2: 186.151,
    y2: 268.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1584_1545",
    x1: 178.252,
    y1: 232.76,
    x2: 186.151,
    y2: 268.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1584_1545",
    x1: 178.252,
    y1: 232.76,
    x2: 186.151,
    y2: 268.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1584_1545",
    x1: 178.252,
    y1: 232.76,
    x2: 186.151,
    y2: 268.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1584_1545",
    x1: 178.252,
    y1: 200.422,
    x2: 186.151,
    y2: 236.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1584_1545",
    x1: 178.252,
    y1: 200.422,
    x2: 186.151,
    y2: 236.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1584_1545",
    x1: 178.252,
    y1: 200.422,
    x2: 186.151,
    y2: 236.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1584_1545",
    x1: 178.252,
    y1: 200.422,
    x2: 186.151,
    y2: 236.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1584_1545",
    x1: 178.252,
    y1: 200.422,
    x2: 186.151,
    y2: 236.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1584_1545",
    x1: 178.252,
    y1: 200.422,
    x2: 186.151,
    y2: 236.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1584_1545",
    x1: 178.252,
    y1: 200.422,
    x2: 186.151,
    y2: 236.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1584_1545",
    x1: 178.252,
    y1: 200.422,
    x2: 186.151,
    y2: 236.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1584_1545",
    x1: 178.252,
    y1: 200.422,
    x2: 186.151,
    y2: 236.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1584_1545",
    x1: 178.252,
    y1: 200.422,
    x2: 186.151,
    y2: 236.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1584_1545",
    x1: 178.252,
    y1: 200.422,
    x2: 186.151,
    y2: 236.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1584_1545",
    x1: 178.252,
    y1: 200.422,
    x2: 186.151,
    y2: 236.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1584_1545",
    x1: 178.252,
    y1: 200.422,
    x2: 186.151,
    y2: 236.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1584_1545",
    x1: 178.252,
    y1: 200.422,
    x2: 186.151,
    y2: 236.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1584_1545",
    x1: 178.252,
    y1: 200.422,
    x2: 186.151,
    y2: 236.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1584_1545",
    x1: 178.252,
    y1: 200.422,
    x2: 186.151,
    y2: 236.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1584_1545",
    x1: 178.252,
    y1: 168.095,
    x2: 186.151,
    y2: 204.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1584_1545",
    x1: 178.252,
    y1: 168.095,
    x2: 186.151,
    y2: 204.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1584_1545",
    x1: 178.252,
    y1: 168.095,
    x2: 186.151,
    y2: 204.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1584_1545",
    x1: 178.252,
    y1: 168.095,
    x2: 186.151,
    y2: 204.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1584_1545",
    x1: 178.252,
    y1: 168.095,
    x2: 186.151,
    y2: 204.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1584_1545",
    x1: 178.252,
    y1: 168.095,
    x2: 186.151,
    y2: 204.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1584_1545",
    x1: 178.252,
    y1: 168.095,
    x2: 186.151,
    y2: 204.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1584_1545",
    x1: 178.252,
    y1: 168.095,
    x2: 186.151,
    y2: 204.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1584_1545",
    x1: 178.252,
    y1: 168.095,
    x2: 186.151,
    y2: 204.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1584_1545",
    x1: 178.252,
    y1: 168.095,
    x2: 186.151,
    y2: 204.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1584_1545",
    x1: 178.252,
    y1: 168.095,
    x2: 186.151,
    y2: 204.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1584_1545",
    x1: 178.252,
    y1: 168.095,
    x2: 186.151,
    y2: 204.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1584_1545",
    x1: 178.252,
    y1: 168.095,
    x2: 186.151,
    y2: 204.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1584_1545",
    x1: 178.252,
    y1: 168.095,
    x2: 186.151,
    y2: 204.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1584_1545",
    x1: 178.252,
    y1: 168.095,
    x2: 186.151,
    y2: 204.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1584_1545",
    x1: 178.252,
    y1: 168.095,
    x2: 186.151,
    y2: 204.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1584_1545",
    x1: 123.18,
    y1: 229.562,
    x2: 123.18,
    y2: 408.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEF9E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransfer);
export default __webpack_public_path__ + "static/media/bank-transfer.b4e43f6071f00b8d9c3dd7c4c1ae3be1.svg";
export { ForwardRef as ReactComponent };